import { Mail, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSendersStore } from '../store/senders.store';

interface SenderEmptyStateProps {
  onCreateClick?: () => void;
}

export const SenderEmptyState = ({ onCreateClick }: SenderEmptyStateProps) => {
  const { t } = useTranslation();
  const { openCreateModal } = useSendersStore();

  const handleCreateClick = () => {
    if (onCreateClick) {
      onCreateClick();
    } else {
      openCreateModal();
    }
  };

  return (
    <div className="rounded-2xl border border-neutral-200 bg-neutral-50 p-8 text-center sm:p-16">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-neutral-100 sm:h-16 sm:w-16">
        <Mail className="h-6 w-6 text-neutral-400 sm:h-8 sm:w-8" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-neutral-900">
        {t('senders.empty.title', 'No senders found')}
      </h3>
      <p className="mx-auto mb-6 max-w-md text-sm text-neutral-600 sm:text-base">
        {t(
          'senders.empty.description',
          'Create your first email sender to start sending automated emails'
        )}
      </p>
      <button
        onClick={handleCreateClick}
        className="bg-primary-600 hover:bg-primary-700 inline-flex items-center gap-2 rounded-xl px-6 py-3 font-semibold text-white transition-colors"
      >
        <Plus className="h-5 w-5" />
        {t('senders.create', 'Create Sender')}
      </button>
    </div>
  );
};
